"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumberGradient = exports.isStringGradient = exports.isGradient = void 0;
// Type guard to check if it is a gradient
const isGradient = (gradient) => typeof gradient !== "string" &&
    ((0, exports.isStringGradient)(gradient) || (0, exports.isNumberGradient)(gradient));
exports.isGradient = isGradient;
// Type guard to check if it is a string gradient
const isStringGradient = (gradient) => typeof gradient !== "string" && gradient.type === "string";
exports.isStringGradient = isStringGradient;
// Type guard to check if it is a number gradient
const isNumberGradient = (gradient) => typeof gradient !== "string" && gradient.type === "number";
exports.isNumberGradient = isNumberGradient;
//# sourceMappingURL=IGradient.js.map